import React, { useState, useEffect } from 'react'
import styles from './../css/Status.module.css'
import StatusRecord from './StatusRecord'
import EditStatus from './EditStatus'
import Spinner from '../../../components/Spinner'
import apiFetch from '../../../api/apiFetch'
import { usePermissions } from '../../../context/PermissionsContext';
import Icon from '../../Icon/Icon';

function Status(props) {

    const permissions = usePermissions();

    const [loaded, setLoaded] = useState(false)
    const [editStatus, setEditStatus] = useState(false)

    useEffect(() => {

        apiFetch(props.endpoints.status, { team: props.exercise.TEAM }).then(
            (data) => {
            props.setStatusData(data)
            setLoaded(true)
        })
    }, [])

    let results = []
    for (let i = 0; i < Object.keys(props.statusData).length; i++) {
        if (props.statusData[i].STATUS.trim() !== "-" && props.statusData[i].STATUS.trim() !== "") {
            results.push(<StatusRecord key={props.statusData[i].STATUS_ID} data={props.statusData[i]} odd={true} />)
        }
    }

    return (<div className={styles.statusWrapper}>
        {editStatus ? <EditStatus endpoints={props.endpoints} user={props.user} exercise={props.exercise} status={props.statusData} setStatus={props.setStatusData} success close={() => { setEditStatus(false) }} /> : ""}
        <div className={styles.sectionTitleBar}>
            <div className={styles.sectionTitle}>Guide</div>
            {
                props.user.role === "ADMIN" 
                    ? (<div className={"icon"} onClick={() => {
                        setEditStatus(true)
                    }}>
                        <Icon name="edit" />
                    </div>)
                    : ""
            }
        </div>
        <div className={styles.results}>
            <div className={styles.contentTitles}>
                <div className={[styles.col, styles.short].join(' ')}>STATUS</div>
                <div className={[styles.col, styles.long].join(' ')}>DESCRIPTION</div>
            </div>
            {
                loaded
                    ? results
                    : <Spinner />
            }
        </div>
    </div>)
}

export default Status
